import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { renderError } from 'services/gecko-error';
import GeckoLocation from 'services/gecko-location';
import GeckoRequest from 'services/gecko-request';
import { deleteIntegration } from '../../../actions/integrations';
import {
  GeckoCardTable,
  GeckoModalService,
  GeckoToastService,
  GECKO_CONSTS,
  GeckoModal,
} from 'ui';
import SlackSetupModal from '../components/SlackSetupModal';
import { getSlackIntegrations } from '../../../selectors/integrations';

const SlackIntegration = (props) => {
  const dispatch = useDispatch();
  const slackWebhooks = useSelector(getSlackIntegrations);

  const openDeleteConfirmModal = (integration) => {
    new GeckoModalService().open(() => (
      <ConfirmDeleteModal integration={integration} />
    ));
  };

  const ConfirmDeleteModal = ({ integration }) => {
    const confirmDeleteBtns = [
      {
        name: 'Cancel',
        handler: () => new GeckoModalService().close(),
      },
      {
        name: 'Remove',
        handler: () => {
          deleteSlackIntegration(integration);
          new GeckoModalService().close();
        },
        type: GECKO_CONSTS.BTN_TYPE_DANGER,
      },
    ];

    return (
      <GeckoModal name="Delete Slack Integration" btns={confirmDeleteBtns}>
        Are you sure you want to remove this Slack Integration
      </GeckoModal>
    );
  };

  const openSlackSetupModal = (integration) => {
    const modalProps = integration
      ? {
          id: integration.id,
          name: integration.name,
          url: integration.configuration.url,
        }
      : {};
    return new GeckoModalService().open(() => {
      return (
        <SlackSetupModal
          values={{
            ...modalProps,
          }}
        />
      );
    });
  };

  const deleteSlackIntegration = (row) => {
    GeckoRequest.delete(`/integration/webhook/${row.id}`)
      .then(() => {
        new GeckoToastService().success('Slack Webhook Deleted');
        dispatch(deleteIntegration(row));
        if (!slackWebhooks?.length) {
          GeckoLocation.goTo('/settings/integrations');
        }
      })
      .catch(renderError);
  };

  const headerButtons = [
    {
      preset: GECKO_CONSTS.BTN_PRESET_ADD,
      handler: openSlackSetupModal,
    },
  ];

  const tableCols = [
    {
      key: 'name',
      name: 'Name',
      width: '30%',
    },
    {
      key: 'configuration.url',
      name: 'Slack Webhook URL',
      width: '50%',
    },
    {
      type: GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN,
      items: [
        {
          name: 'Edit',
          handler: openSlackSetupModal,
        },
        {
          name: 'Remove',
          icon: 'far fa-trash-alt',
          handler: openDeleteConfirmModal,
        },
      ],
    },
  ];

  return (
    <div className="content-margin">
      <GeckoCardTable
        name="Slack Integration"
        cols={tableCols}
        rows={slackWebhooks}
        headerBtns={headerButtons}
        pagination={{ total_items: slackWebhooks.length }}
        rowHandler={(row) => openSlackSetupModal(row)}
      />
    </div>
  );
};

export default SlackIntegration;
